<app-stages [stages]="stages" currentStage="Informacje o wycince"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <app-property-owner-form [form]="form">
    </app-property-owner-form>
    <fieldset>
      <legend>
        Termin wycinki
      </legend>
      <div class="row">
        <div class="col-md-4">
          <div class='form-group' *ngIf='"intendedRemovalDate" as controlName'>
            <label [for]='controlName'>
              Termin zamierzonego usunięcia drzewa/krzewu (Data do) *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>Lista drzew i krzewów do wycinki</legend>
      <br>
      <app-trees-to-remove-preview
        [canEdit]="(currentTreeItemIndex === undefined) && !treeItemFormType"
        (onRemove)="form.removeTreeToRemove($event)"
        (onEdit)="onEditTreeItemForm($event.i, $event.v)"
        [showActions]="true"
        [treesToRemove]="form.treesToRemoveValues">
      </app-trees-to-remove-preview>
      <br>
      @if (treeItemFormType) {
        <app-tree-to-remove-item-form
          [treeItemFormType]="treeItemFormType"
          (submit)="onSubmitTreeItemForm($event)"
          (cancel)="onCancelTreeItemForm()"
          [form]="treeToRemoveItemForm"
          [edit]="!!treeItemFormType">
        </app-tree-to-remove-item-form>
      } @else {
        <div class="form-actions">
          <button class="btn btn-primary" type="button" (click)="onAddTreeItemForm('tree')">
            Dodaj drzewo
          </button>
          <button class="btn btn-primary" type="button" (click)="onAddTreeItemForm('shrub')">
            Dodaj krzew
          </button>
        </div>
      }
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        [disabled]="pending() || treeItemFormType"
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
